import React, { useState } from "react";
import { Row, Button, Input, Spinner } from "reactstrap";
import fbvector from "assets/img/socialIcons/fbVector.svg";
import insta from "assets/img/socialIcons/insta.svg";
import twiterVector from "assets/img/icons/twitter (1).png";
import snapchat from "assets/img/socialIcons/snapchat.svg";
import discord from "assets/img/socialIcons/discord.svg";
import linkedIn from "assets/img/socialIcons/linkedinVector.svg";
import website from "assets/img/socialIcons/website.svg";
import linktree from "assets/img/socialIcons/linktree.svg";
import youtube from "assets/img/socialIcons/youtube.svg";
import tiktok from "assets/img/socialIcons/tiktok.svg";
import { useDispatch, useSelector } from "react-redux";
import { updateSocialProfile } from "store/actions/settingAction";
import TableComponent from "components/shared/Table";

const SocialProfileTable = ({ data }) => {
  const dispatch = useDispatch();
  const { restaurantMedia } = useSelector((state) => state.restaurant);
  const { user } = useSelector((state) => state.auth);

  const [loading, setLoading] = useState(false);
  const [url, setUrl] = useState("");
  const [editIndex, setEditIndex] = useState(-1);
  const [urlError, setUrlError] = useState("");

  const validateURL = (type, url) => {
    const regexMap = {
      facebook: /^https?:\/\/(www\.)?facebook\.com\/[A-Za-z0-9_.-]+\/?$/,
      twiter: /^https?:\/\/(www\.)?(x|twitter)\.com\/[A-Za-z0-9_]{1,15}\/?$/,
      instagram: /^https?:\/\/(www\.)?instagram\.com\/[A-Za-z0-9_.-]+\/?$/,
      tiktok: /^https?:\/\/(www\.)?tiktok\.com\/@[A-Za-z0-9_.-]+\/?$/,
      linkedIn: /^https?:\/\/(www\.)?linkedin\.com\/in\/[A-Za-z0-9_.-]+\/?$/,
      youtube: /^https?:\/\/(www\.)?youtube\.com\/[A-Za-z0-9_.-]+\/?$/,
      discord: /^https?:\/\/(www\.)?discord\.com\/[A-Za-z0-9_.-]+\/?$/,
      snapchat: /^https?:\/\/(www\.)?snapchat\.com\/add\/[A-Za-z0-9_.-]+\/?$/,
      linktree: /^https?:\/\/(www\.)?linktr\.ee\/[A-Za-z0-9_.-]+\/?$/,
      website:
        /^https?:\/\/(localhost|([A-Za-z0-9-]+\.)+[A-Za-z]{2,})(:[0-9]{1,5})?(\/.*)?$/,
    };

    const urlExamples = {
      facebook: "https://www.facebook.com/your-profile",
      twiter: "https://www.x|twitter.com/your-username",
      instagram: "https://www.instagram.com/your-profile",
      tiktok: "https://www.tiktok.com/@your-username",
      linkedIn: "https://www.linkedin.com/in/your-profile",
      youtube: "https://www.youtube.com/your-channel",
      discord: "https://www.discord.com/your-profile",
      snapchat: "https://www.snapchat.com/add/your-username",
      linktree: "https://www.linktr.ee/your-username",
      website: "https://your-website.com",
    };

    const platformRegex = regexMap[type];
    setUrlError("");

    if (platformRegex && platformRegex.test(url)) {
      return true;
    } else {
      setUrlError(
        type === "website"
          ? `Please enter a valid website URL (e.g., ${urlExamples[type]}).`
          : `Please enter a valid ${type} URL (e.g., ${urlExamples[type]}).`
      );
      return false;
    }
  };

  const updatedData = [
    { type: "facebook", icon: fbvector },
    { type: "instagram", icon: insta },
    { type: "tiktok", icon: tiktok },
    { type: "discord", icon: discord },
    { type: "youtube", icon: youtube },
    { type: "website", icon: website },
    { type: "linktree", icon: linktree },
    { type: "linkedIn", icon: linkedIn },
    { type: "snapchat", icon: snapchat },
    { type: "twiter", icon: twiterVector },
  ];

  const updatedSocialProfiles = data?.map((profile) => {
    const matchingIcon = updatedData.find((item) => item.type === profile.type);
    return matchingIcon
      ? { ...profile, icon: matchingIcon.icon, url: profile.url || "" }
      : profile;
  });

  const handleUpdate = (type, url) => {
    dispatch(updateSocialProfile(user?.restaurantID, type, url)).then(() => {
      setLoading(false);
      setEditIndex(-1);
    });
  };

  return (
    <>
      <Row className="py-4">
        <div className="col">
          <div className="d-flex justify-content-between py-3">
            <div className="d-flex align-items-center">
              <h3 className="pt-2">Social Profiles</h3>
            </div>
          </div>

          <div className="border border-top-0 rounded overflow-hidden">
            <TableComponent
              className="align-items-center table-flush"
              responsive
              bordered
            >
              <thead className="thead-light">
                <tr>
                  <th scope="col">Type</th>
                  <th scope="col">URL</th>
                  <th scope="col">Actions</th>
                </tr>
              </thead>
              <tbody>
                {updatedSocialProfiles?.map((item, index) => (
                  <tr key={index}>
                    <td>
                      <div
                        className="d-flex justify-content-center align-items-center p-1 rounded-circle object-cover"
                        style={{
                          background: restaurantMedia?.adminColor || "#d70365",
                          width: "35px",
                          height: "35px",
                        }}
                      >
                        <img
                          src={item.icon}
                          alt="Social Link"
                          id={item.type}
                          // className="img-fluid"
                        />
                      </div>
                    </td>
                    <td className="align-middle">
                      {index === editIndex ? (
                        <>
                          <Input
                            type={item.type === "website" ? "url" : "text"}
                            value={url}
                            onChange={(e) => setUrl(e.target.value)}
                            className="d-flex"
                            style={{ height: "38px" }}
                          />
                          {urlError && editIndex === index && (
                            <span
                              className="text-danger d-block"
                              style={{ fontSize: "11px" }}
                            >
                              {urlError}
                            </span>
                          )}
                        </>
                      ) : (
                        <a
                          href={item.url}
                          target="_blank"
                          rel="noreferrer"
                          className="d-flex border-bottom-0 align-items-center text-truncate"
                        >
                          {item.url}
                        </a>
                      )}
                    </td>

                    <td>
                      <div style={{ minWidth: 120 }}>
                        {index === editIndex ? (
                          <>
                            <Button
                              size="sm"
                              color="success"
                              onClick={() => {
                                if (url && validateURL(item.type, url)) {
                                  setLoading(true);
                                  handleUpdate(item.type, url);
                                }
                              }}
                              disabled={loading}
                            >
                              {loading ? (
                                <Spinner size="sm" />
                              ) : item.url ? (
                                "Update"
                              ) : (
                                "Add"
                              )}
                            </Button>
                            <Button
                              size="sm"
                              color="danger"
                              onClick={() => {
                                setEditIndex(null);
                                setUrlError("");
                                setUrl("");
                              }}
                            >
                              Cancel
                            </Button>
                          </>
                        ) : (
                          <Button
                            size="sm"
                            color="primary"
                            onClick={() => {
                              setUrlError("");
                              setEditIndex(index);
                              setUrl(item.url);
                            }}
                          >
                            Edit
                          </Button>
                        )}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </TableComponent>
          </div>
        </div>
      </Row>
    </>
  );
};

export default SocialProfileTable;
